import {ref} from 'vue'
export  const rechargeHtmlData = ref(null)